import { getRoleEnumById } from "@/common/common-function";
import {
  ROLE_ADMIN,
  ROLE_DEPUTY,
  ROLE_HEAD,
  ROLE_HR,
  ROLE_MANAGER,
  ROLE_MEETING,
  ROLE_PLAN,
  ROLE_USER,
} from "@/common/constant.js";

export const USER_ROLES = {
  ADMIN: {
    NAME: ROLE_ADMIN.roleCode,
    ROUTERS: ["Home", "SettingCommon"],
  },
  PLAN: {
    NAME: ROLE_PLAN.roleCode,
    ROUTERS: [
      "Home",
      "ManagerTargetSettings",
      "TargetSetting",
      "PersonalTarget",
      "PersonalTargetMobile",
    ],
  },
  HEAD: {
    NAME: ROLE_HEAD.roleCode,
    ROUTERS: [
      "Home",
      "ManagerTargetSettings",
      "TargetSetting",
      "TeamTarget",
      "TeamTarget-member",
      "PersonalTarget",
      "MemberTransferSetting",
      "PersonalTargetMobile",
    ],
  },
  DEPUTY: {
    NAME: ROLE_DEPUTY.roleCode,
    ROUTERS: [
      "Home",
      "TeamTarget",
      "TeamTarget-member",
      "PersonalTarget",
      "PersonalTargetMobile",
    ],
  },
  MANAGER: {
    NAME: ROLE_MANAGER.roleCode,
    ROUTERS: [
      "Home",
      "TeamTarget",
      "TeamTarget-member",
      "PersonalTarget",
      "PersonalTargetMobile",
    ],
  },
  USER: {
    NAME: ROLE_USER.roleCode,
    ROUTERS: [
      "Home",
      "TeamTarget",
      "TeamTarget-member",
      "PersonalTarget",
      "PersonalTargetMobile",
    ],
  },
  MEETING: {
    NAME: ROLE_MEETING.roleCode,
    ROUTERS: ["Home", "TeamTarget", "TeamTarget-member"],
  },
  HR: {
    NAME: ROLE_HR.roleCode,
    ROUTERS: [
      "Home",
      "SettingCommon",
      "MemberTransferSetting",
      "History",
      "DataCollection",
      "DataCollectionDetail",
    ],
  },
};

export function checkRoles(routeName, permissions) {
  if (!permissions) {
    return false;
  }
  const even = (role) =>
    USER_ROLES[role] && USER_ROLES[role].ROUTERS.includes(routeName);
  return permissions.some(even);
}

export const rolesCanReview = {
  [ROLE_MEETING.roleCode]: [
    ROLE_HEAD.roleCode,
    ROLE_DEPUTY.roleCode,
    ROLE_MANAGER.roleCode,
    ROLE_USER.roleCode,
  ],
  [ROLE_HEAD.roleCode]: [
    ROLE_DEPUTY.roleCode,
    ROLE_MANAGER.roleCode,
    ROLE_USER.roleCode,
  ],
  [ROLE_DEPUTY.roleCode]: [ROLE_MANAGER.roleCode, ROLE_USER.roleCode],
  [ROLE_MANAGER.roleCode]: [ROLE_USER.roleCode],
  [ROLE_USER.roleCode]: [],
};

export const getHighestRole = (roles) => {
  return roles
    .filter((role) => role !== ROLE_PLAN.roleCode)
    .sort((a, b) => getRoleEnumById(a).roleId - getRoleEnumById(b).roleId)[0];
};
